var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isSelecting)?_c('Login'):_c('router-view'),_c('WalletBoard',{attrs:{"chains":_vm.computedChains},on:{"wallets":_vm.getWallets,"disconnected":_vm.disconnected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }